var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('OtDialog',[(_vm.initialized)?_c('div',{staticClass:"app__content"},[_c('router-view')],1):_c('div',{staticClass:"ot-spinner"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }